import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/workOrder/${number | ':workOrderId'}/account/${number | ':accountId'}/hasOverlaps`;

export const ROUTE: RouteDefinition = `${baseRoute}/workOrder/:workOrderId/account/:accountId/hasOverlaps`;

export const URL = (workOrderId: number, accountId: number): RouteDefinition =>
	`${baseRoute}/workOrder/${workOrderId}/account/${accountId}/hasOverlaps`;
